import { BuyerLayout } from '../layouts/BuyerLayout';
import { PublicLayout } from '../layouts/public';

interface AuthBasedLayoutProps {
  isAuthenticated: boolean;
  containerClassname?: string;
  children: React.ReactNode;
}

export const AuthBasedLayout: React.FC<AuthBasedLayoutProps> = ({
  isAuthenticated,
  containerClassname = '',
  children,
}) => {
  if (isAuthenticated) {
    return (
      <BuyerLayout containerClassname={containerClassname}>
        {children}
      </BuyerLayout>
    );
  }

  return (
    <PublicLayout containerClassname={containerClassname}>
      {children}
    </PublicLayout>
  );
};
